import get from 'lodash/get';

const getSeoPageTitle = (seo, pageData = {}) =>
  get(seo, 'title.value', get(pageData, 'name', get(pageData, 'pageTitle', '')));

export default getSeoPageTitle;
